var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs3066"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3129",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3130",
    stopOpacity: 0.5,
    stopColor: "#e8d7d3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3131",
    stopOpacity: 0,
    stopColor: "#d9b8af",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3133",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3134",
    stopOpacity: 0.5,
    stopColor: "#e8d7d3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3135",
    stopOpacity: 0,
    stopColor: "#d9b8af",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3218",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3219",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3220",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3222",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3223",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3224",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3228",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3229",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3230",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3232",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3233",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3234",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3236",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3237",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3238",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3241",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3242",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3243",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3245",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3246",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3247",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3251",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3252",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3253",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3255",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3256",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3257",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3259",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3260",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3261",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3685",
    x1: 100,
    y1: 172,
    x2: 100,
    y2: 128.5,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3686",
    stopOpacity: 0.8,
    stopColor: "#ca9b8e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3687",
    stopOpacity: 1,
    stopColor: "#ab6957",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4441",
    cx: 125.379,
    cy: 82.93,
    r: 12.84,
    gradientTransform: "matrix(-1.0592 4.000000e-004 -4.000000e-004 0.9318 206.5112 5.1767)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4442",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4443",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4444",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4445",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4446",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4447",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4449",
    cx: 125.001,
    cy: 82.93,
    r: 12.841,
    gradientTransform: "matrix(1.0592 4.000000e-004 4.000000e-004 0.9318 -6.5112 5.1767)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4450",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4451",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4452",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4453",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4454",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4455",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4457",
    cx: 125.379,
    cy: 82.93,
    r: 12.84,
    gradientTransform: "matrix(-1.0592 4.000000e-004 -4.000000e-004 0.9318 206.5112 5.1767)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4458",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4459",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4460",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4461",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4462",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4463",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4467",
    cx: 123.218,
    cy: 81.096,
    fx: 133.802,
    fy: 77.197,
    r: 17.898,
    gradientTransform: "matrix(0.9998 0.0183 0.0166 -0.7038 -47.7588 136.6255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4468",
    stopOpacity: 1,
    stopColor: "#ca9b8e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4469",
    stopOpacity: 0.3,
    stopColor: "#ca9b8e",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4470",
    stopOpacity: 0,
    stopColor: "#d9b8af",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4472",
    cx: 79.496,
    cy: 81.496,
    r: 23.208,
    gradientTransform: "matrix(1.0971 -0.0499 0.0576 0.9543 -20.1632 27.912)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4473",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4474",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4478",
    cx: 125.001,
    cy: 82.93,
    r: 12.841,
    gradientTransform: "matrix(1.0592 4.000000e-004 4.000000e-004 0.9318 -6.5112 5.1767)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4479",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4480",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4481",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4482",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4483",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4484",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4488",
    cx: 122.818,
    cy: 81.096,
    fx: 133.402,
    fy: 77.197,
    r: 17.898,
    gradientTransform: "matrix(-0.9998 0.0183 -0.0166 -0.7038 246.9601 136.6328)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4489",
    stopOpacity: 1,
    stopColor: "#ca9b8e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4490",
    stopOpacity: 0.3,
    stopColor: "#ca9b8e",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4491",
    stopOpacity: 0,
    stopColor: "#d9b8af",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4493",
    cx: 79.859,
    cy: 81.511,
    r: 23.208,
    gradientTransform: "matrix(-1.0971 -0.0499 -0.0576 0.9543 220.163 27.9157)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4494",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4495",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4660",
    x1: 72,
    y1: 106,
    x2: 72,
    y2: 69,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4661",
    stopOpacity: 0.95,
    stopColor: "#000000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4662",
    stopOpacity: 1,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4673",
    x1: 130,
    y1: 77,
    x2: 130,
    y2: 98,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4674",
    stopOpacity: 1,
    stopColor: "#26120b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4675",
    stopOpacity: 0.5,
    stopColor: "#26120b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4677",
    x1: 130,
    y1: 77,
    x2: 130,
    y2: 98,
    gradientTransform: "matrix(-1 0 0 1 200 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4678",
    stopOpacity: 1,
    stopColor: "#26120b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4679",
    stopOpacity: 0.5,
    stopColor: "#26120b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4720",
    x1: 100,
    y1: 142,
    x2: 100,
    y2: 139,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4721",
    stopOpacity: 1,
    stopColor: "#d1a99e",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4722",
    stopOpacity: 1,
    stopColor: "#ca9b8e",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4602",
    d: "M225 225H-25V-25h250V225z",
    fill: "#ffcd02",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(0.8499995000000001,0,0,0.8499995000000001,15.000123278194536,16.53862286232375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4565",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3136",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#d9b8af",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3137",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#e8d7d3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3138",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#ca9b8e",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3139",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#ab6957",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3684",
    d: "M117.136 169.742c2.515-1.069 5.217-3.028 7.927-5.519 -0.494-0.746-0.828-1.684-0.841-2.49 -0.093-7.296 1.775-22.369 3.054-31.753 -15.779-1.925-38.771-1.917-54.549 0.014 1.278 9.384 3.145 24.446 3.05 31.738 -0.01 0.789-0.348 1.735-0.84 2.485 2.712 2.493 5.416 4.454 7.932 5.524C90.312 172.907 109.693 172.907 117.136 169.742z",
    fill: "url(#SvgjsLinearGradient3685)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4591",
    d: "M128.857 237.978H70.72v-56.183c22.25 4.699 36.88 4.337 58.138 0V237.978z",
    fill: "#f3f1f3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4592",
    d: "M107.44 237.709c-2.775 0-10.727 0.208-16.512-0.23l-0.01-0.171c-0.818-18.658 1.129-30.719 4.537-39.288l0.048-0.123 -0.093-0.093c-0.905-0.904-2.425-1.935-4.034-3.025 -1.611-1.093-3.275-2.221-4.336-3.246 0.625-0.732 1.395-1.454 2.348-2.201 0.245-0.125 1.162-0.843 5.974-4.971 0.214-0.184 0.345-0.296 0.362-0.31 0.818-0.178 2.138-0.293 3.738-0.293 2.183 0 4.731 0.221 6.512 0.563 1.561 1.458 3.451 5.329 4.158 7.17 -0.976 2.291-2.128 3.129-3.717 4.284 -0.774 0.563-1.652 1.201-2.652 2.112l-0.083 0.075 0.021 0.111c4.026 20.31 4.027 25.054 4.027 29.642 0.001 2.021 0.001 6.609 0.339 9.985C107.917 237.707 107.704 237.709 107.44 237.709z",
    fill: "#131111",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4593",
    d: "M110.35 191.495c-0.754-1.995-2.71-5.93-4.28-7.359 -2.876-0.563-7.983-0.843-10.47-0.24 -0.108 0.088-6.248 5.383-6.31 5.26 -0.906 0.708-1.788 1.504-2.52 2.39 2.061 2.076 6.655 4.556 8.5 6.4 -3.65 9.18-5.33 21.59-4.55 39.38 0.01 0.11 0.01 0.23 0.02 0.34 6.756 0.52 16.55 0.331 17.55 0.223 -1.16-11.307 1.438-10.455-4.39-39.853C106.968 195.241 108.865 195.04 110.35 191.495zM105.1 210.535c-0.021-0.05-0.04-0.1-0.051-0.13 2 10.55 1.38 18.632 2.891 26.972 -4.736-0.318-12.014-0.052-16.771-0.052 0.369-7.198 1.188-31.684 4.74-39.74 0.17-0.046 0.339-0.084 0.509-0.125l-1.032 34.736 2.747-35.066c0.02-0.002 0.04-0.005 0.06-0.008l1.801 32.605 0.417-32.734c0.026 0.001 0.051-0.001 0.077 0l4.199 36.355 -2.3-36.137c0.314 0.063 0.629 0.141 0.942 0.233 0.03 0 0.07 0.01 0.1 0.03C103.533 198.476 104.365 205.876 105.1 210.535zM104.219 196.726c-2.774-1.251-6.363-1.026-9.129 0.24 -1.681-1.813-4.08-3.077-7.53-5.391 0.55-0.479 1.26-1.07 2.21-1.81 0.08 0 3.48-2.771 3.54-2.83 0.92-0.84 1.74-1.79 2.52-2.62 2.93-0.12 7.23 0.02 9.82 0.14 1.5 1.876 2.931 4.696 4.01 6.94C107.699 194.266 105.759 195.545 104.219 196.726z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4594",
    d: "M78.196 213.077c-11.534-40.071-6.325-29.581-9.399-45.32 2.028-4.813 3.958-10.44 5.042-11.598l0.08-0.086c2.292 24.007 8.958 13.636 23.784 27.722C89.228 189.449 81.372 204.127 78.196 213.077zM131.193 167.758c-1.448-3.702-4.077-9.127-5.215-10.331 1.424 20.678-15.146 16.551-24.35 26.2 8.812 5.713 17.173 20.66 20.172 29.455C134.92 169.568 127.85 188.673 131.193 167.758z",
    fill: "#f3f1f4",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4595",
    d: "M125.801 156.967c0 5.137-0.42 9.162-1.262 10.339 -2.443 5.809-13.103 9.853-16.39 11.51 -2.495 1.227-4.942 2.809-6.83 4.85 3.813 2.476 5.705 3.383 12.93 14.44 4.246 7.109 6.539 12.448 7.561 15.64 13.378-44.331 6.222-24.978 9.59-46.01C129.814 163.65 126.801 157.885 125.801 156.967zM129.449 176.495c-1.957 18.078-3.491 14.485-7.74 34.181 -2.716-8.644-11.075-22.913-19.43-27.091 3.937-2.957 5.031-3.131 9.729-5.279 14.396-6.42 14.985-12.385 14.138-20.271 1.207 1.423 3.125 6.161 4.692 9.521C129.979 170.702 129.589 175.194 129.449 176.495zM79.199 171.896c-4.408-3.649-3.16-8.162-5.189-16.215 -0.902 1-3.146 6.632-5.42 12.055 0.557 2.796 0.681 7.389 0.76 8.84 0.559 12.202 1.75 12.765 8.83 37.16 3.031-8.905 11.558-24.37 20.24-30.009C91.489 177.401 82.765 174.999 79.199 171.896zM84.659 197.405c-2.221 3.666-4.517 7.48-6.37 13.28 -4.442-20.269-5.999-16.964-7.73-34.16 -0.32-2.971-0.617-6.027-1.4-8.96 1.638-3.588 3.981-10.281 4.731-10.995 1.366 7.078 0.066 13.462 5.669 16.995 2.621 1.996 11.104 5.32 17.52 10.36C93.188 186.235 91.094 187.596 84.659 197.405z",
    fill: "#cfc8d7",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4596",
    d: "M120.319 209.824l-1.209-2.654c0 0 9.148-28.175 10.743-36.225C130.765 179.299 120.319 209.824 120.319 209.824zM78.879 208.721l1.436-3.259c0 0-8.573-26.467-10.168-34.517C69.235 179.299 78.879 208.721 78.879 208.721z",
    fill: "#e1e0e1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4597",
    d: "M124.787 195.605c7.065-20.834 2.756-22.551 6.305-29.469 0.134-0.261 1.396 1.046 1.533 1.64 1.306 5.658 53.349 17.338 54.994 18.598 1.456 1.058 5.65 3.137 5.65 3.137 4.937 9.07 7.762 10.698 9.15 34.984 0.13 3.083-0.061 11.801-0.061 14.141l-85.559-0.676C117.004 230.169 117.999 216.15 124.787 195.605zM75.213 195.605c-7.065-20.834-2.756-22.551-6.305-29.469 -0.134-0.261-1.396 1.046-1.533 1.64 -1.306 5.658-53.349 17.338-54.994 18.598 -1.456 1.058-5.65 3.137-5.65 3.137 -4.937 9.07-7.762 10.698-9.15 34.984 -0.13 3.083 0.061 11.801 0.061 14.141l85.559-0.676C82.996 230.169 82.001 216.15 75.213 195.605z",
    fill: "#1d282e",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4598",
    d: "M130.307 190c-4.552 16.387-10.771 31.116-13.506 47.96 -0.89-0.007 1.491-22.695 7.986-42.354 7.065-20.834 2.756-22.551 6.305-29.469 0.077-0.15-0.619 1.976-0.223 2.432C130.723 176.296 132.625 182.272 130.307 190zM69.693 190c4.552 16.387 10.771 31.116 13.506 47.96 0.89-0.007-1.491-22.695-7.986-42.354 -7.065-20.834-2.756-22.551-6.305-29.469 -0.077-0.15 0.619 1.976 0.223 2.432C69.277 176.296 67.375 182.272 69.693 190z",
    fill: "#101a1f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4599",
    d: "M152.436 186.031c0 0-2.284 2.561-8.636 6.923 5.313-5.885 7.761-8.249 7.761-8.249L152.436 186.031zM154.611 197.906l-1.528-1.367c-4.538 13.781-7.571 20.587-12.828 36.618C147.799 218.831 149.599 213.745 154.611 197.906zM48.439 184.705c0 0 2.447 2.364 7.761 8.249 -6.352-4.362-8.636-6.923-8.636-6.923L48.439 184.705zM59.745 233.157c-5.257-16.031-8.29-22.837-12.828-36.618l-1.528 1.367C50.401 213.745 52.201 218.831 59.745 233.157z",
    fill: "#070c0f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4600",
    d: "M179.409 219.335c0-11.596 3.11-18.351 9.615-28.142 0.608 0.372 0.931 0.543 1.345 0.875C183.452 200.651 182.078 208.659 179.409 219.335zM141.312 230.703c6.113-16.703 8.06-23.228 12.107-34.388 -1.15-0.351-8.671-2.985-9.819-3.346 0.41 1 3.113 1.822 7.822 4.709C151.422 197.679 146.333 213.082 141.312 230.703zM149.533 184.577c0 0-3.352 4.14-6.664 8.328 3.388-2.67 5.748-5.644 8.691-8.2 -3.994-3.368-10.511-8.524-14.721-12.089C140.163 176.188 149.533 184.577 149.533 184.577zM202.073 238.634l0.286 0.002c0-2.34 0.19-11.058 0.061-14.141 -1.389-24.286-4.214-25.914-9.15-34.984 0 0-4.194-2.079-5.65-3.137 -1.334-1.021-38.794-9.922-52.49-15.88 16.011 10.971 46.282 15.027 55.24 21.574C194.702 195.235 200.535 222.337 202.073 238.634zM9.613 192.037c0.542-0.383 0.619-0.366 1.168-0.729 6.505 9.791 9.809 16.431 9.809 28.026C17.922 208.659 16.08 200.318 9.613 192.037zM48.578 197.679c4.709-2.887 7.412-3.709 7.822-4.709 -1.148 0.36-8.669 2.995-9.819 3.346 4.048 11.16 5.994 17.685 12.107 34.388C53.667 213.082 48.578 197.679 48.578 197.679zM63.16 172.616c-4.21 3.564-10.727 8.721-14.721 12.089 2.943 2.557 5.304 5.53 8.691 8.2 -3.313-4.188-6.664-8.328-6.664-8.328S59.837 176.188 63.16 172.616zM9.631 192.068c8.958-6.547 39.229-10.604 55.24-21.574 -13.696 5.958-51.156 14.858-52.49 15.88 -1.456 1.058-5.65 3.137-5.65 3.137 -4.937 9.07-7.762 10.698-9.15 34.984 -0.13 3.083 0.061 11.801 0.061 14.141l0.286-0.002C-0.535 222.337 5.298 195.235 9.631 192.068z",
    fill: "#2d373d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4601",
    d: "M132.246 166.374c-0.049-0.293-0.443-0.634-0.738-0.657 -0.296-0.023-0.432 0.458-0.567 0.722 -3.549 6.918 0.414 8.333-6.651 29.167 -6.788 20.545-7.584 34.862-7.787 42.653l85.857 0.377c0-2.34 0.489-11.058 0.359-14.141 -1.389-24.286-4.313-26.113-9.25-35.184 0 0-4.394-2.179-5.85-3.236 -4.889-3.742-0.59 0.023-22.03-6 -17.576-5.135-18.525-6.577-24.899-8.35 -1.288-0.369-4.057-0.822-6.95-2.851C133.475 168.689 132.341 166.944 132.246 166.374zM116.974 237.31c3.729-23.564 6.085-29.73 11.296-47.274 3.522-11.104 1.576-17.408 3.254-22.54 0.088-0.268 0.467-0.282 0.571-0.017 2.434 6.214 9.238 7.656 18.834 17.047 -5.813 5.813-7.309 7.38-8.06 8.38 0.864 0.438 5.582 2.229 9.9 3.9 -0.245 0.767-13.415 38.02-13.57 38.52 10-21.578 11.292-28.211 14.22-39.01 -0.812-0.612-7.892-3.212-9.09-3.64 4.274-4.424 5.51-5.396 7.53-7.971 1.622 0-15.874-13.318-16.73-14.211 0.462 0.364 2.752 1.391 3.01 1.491 14.682 5.166 3.065 2.829 35.2 12.001 3.072 0.781 7.355 1.567 10.53 1.879 0.218 0.02 5.395 2.727 8.35 3.97 -7.189 7.475-11.797 17.133-12.81 29.5 3.219-12.666 4.951-19.29 13.14-28.819 7.62 15.422 6.755 13.195 9.23 47.71C181.167 237.413 149.559 237.227 116.974 237.31zM66.261 168.875c-2.894 2.028-5.662 2.481-6.95 2.851 -6.374 1.772-7.323 3.215-24.899 8.35 -21.44 6.023-17.142 2.258-22.03 6 -1.456 1.058-5.85 3.236-5.85 3.236 -4.937 9.07-7.861 10.897-9.25 35.184 -0.13 3.083 0.359 11.801 0.359 14.141l85.857-0.377c-0.203-7.791-0.999-22.108-7.787-42.653 -7.065-20.834-3.103-22.249-6.651-29.167 -0.136-0.264-0.271-0.745-0.567-0.722 -0.295 0.023-0.689 0.364-0.738 0.657C67.659 166.944 66.525 168.689 66.261 168.875zM-1.779 238.226c2.476-34.515 1.61-32.288 9.23-47.71 8.188 9.529 9.921 16.153 13.14 28.819 -1.013-12.367-5.62-22.025-12.81-29.5 2.955-1.243 8.132-3.95 8.35-3.97 3.175-0.312 7.458-1.098 10.53-1.879 32.135-9.172 20.519-6.835 35.2-12.001 0.258-0.101 2.548-1.127 3.01-1.491 -0.856 0.893-18.353 14.211-16.73 14.211 2.021 2.575 3.256 3.547 7.53 7.971 -1.198 0.428-8.278 3.027-9.09 3.64 2.928 10.799 4.22 17.432 14.22 39.01 -0.155-0.5-13.325-37.753-13.57-38.52 4.318-1.672 9.036-3.463 9.9-3.9 -0.751-1-2.247-2.567-8.06-8.38 9.596-9.391 16.4-10.833 18.834-17.047 0.104-0.266 0.483-0.251 0.571 0.017 1.678 5.132-0.269 11.436 3.254 22.54 5.211 17.544 7.567 23.71 11.296 47.274C50.441 237.227 18.833 237.413-1.779 238.226z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3393",
    d: "M46.778 83.613c-2.623-1.48-8.575-8.52-11.138-7.517 -1.655 0.646-2.377 5.504-2.638 7.47 -0.333 2.525-0.929 7.711-0.328 10.185 0.725 2.985 3.631 8.507 5.37 11.027 1.468 2.122 5.211 5.797 6.407 8.088 0.759 1.454 1.493 5.373 4.083 5.12 1.674-0.164 5.537-3.072 5.744-4.452C55.406 106.057 51.943 86.528 46.778 83.613z",
    fill: "#d9b8af",
    stroke: "#ab6957",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3394",
    d: "M43.313 99.76c-0.125-0.556 0.006-1.491 0.133-2.395 0.115-0.824 0.224-1.601 0.158-2.151 -0.251-2.06-1.66-5.975-2.578-8.097 -1.059-2.44-2.771-5.515-4.919-6.307 -0.888-0.33-1.473 0.063-1.813 0.461 -0.248 0.292-0.305 0.636-0.223 0.676 0.082 0.041 0.266-0.244 0.535-0.512 0.219-0.219 0.542-0.407 0.983-0.368 -0.178 1.026-1.091 6.582-0.696 10.369 0.311 2.978 1.489 5.202 1.673 5.536 0.028 0.352 0.073 0.695 0.139 1.028 0.869 4.347 4.648 9.29 5.963 10.908 0.243 0.298 0.496 0.476 0.56 0.404 0.062-0.074-0.087-0.368-0.33-0.668 -1.298-1.609-5.042-6.533-5.879-10.728 -0.89-4.45 2.167-11.048 2.849-12.443 0.348 0.655 0.643 1.285 0.87 1.809 0.179 0.412 0.378 0.894 0.581 1.414 -0.402 0.729-3.211 6.042-2.187 10.295 0.38 1.568 2.088 3.589 3.223 4.143 0.624 0.306 0.859 0.761 1.13 1.288 0.314 0.613 0.673 1.307 1.708 1.81 0.211 0.101 0.402 0.144 0.571 0.144 0.293 0 0.515-0.126 0.679-0.281 0.017 0.268 0.016 0.611 0.007 0.928 -0.01 0.411 0.041 0.747 0.129 0.756 0.088 0.008 0.182-0.318 0.192-0.726 0.016-0.503 0.013-1.125-0.067-1.422 -0.232-0.877-0.942-1.867-1.694-2.915C44.27 101.685 43.504 100.618 43.313 99.76zM36.538 95.905c-2.035-6.825 0-13.093 0.458-14.029 0.795 0.785 2.108 2.213 2.679 3.239C39.258 85.938 36.623 91.315 36.538 95.905zM45.318 105.891c-0.938-0.456-1.253-1.067-1.557-1.657 -0.275-0.535-0.56-1.087-1.281-1.44 -0.157-0.077-0.33-0.193-0.505-0.328 -2.324-5.988 0.254-8.606 0.899-9.142 0.199 0.731 0.346 1.403 0.411 1.941 0.061 0.495-0.05 1.28-0.156 2.041 -0.132 0.942-0.268 1.916-0.127 2.546 0.211 0.94 0.999 2.038 1.76 3.1 0.677 0.943 1.373 1.915 1.609 2.708C46.271 105.818 45.949 106.195 45.318 105.891z",
    fill: "#ab6957",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3395",
    d: "M152.961 83.613c2.623-1.48 8.574-8.52 11.137-7.517 1.656 0.646 2.379 5.504 2.639 7.47 0.334 2.525 0.928 7.711 0.328 10.185 -0.725 2.985-3.631 8.507-5.371 11.027 -1.467 2.122-5.211 5.797-6.406 8.088 -0.76 1.454-1.492 5.373-4.084 5.12 -1.674-0.164-5.535-3.072-5.744-4.452C144.332 106.057 147.795 86.528 152.961 83.613z",
    fill: "#d9b8af",
    stroke: "#ab6957",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3396",
    d: "M154.729 102.716c-0.752 1.047-1.463 2.038-1.695 2.915 -0.078 0.297-0.082 0.919-0.066 1.422 0.012 0.407 0.105 0.733 0.193 0.726 0.088-0.009 0.139-0.345 0.129-0.756 -0.01-0.316-0.01-0.66 0.006-0.928 0.164 0.155 0.387 0.281 0.68 0.281 0.168 0 0.359-0.043 0.57-0.144 1.035-0.503 1.395-1.196 1.709-1.81 0.271-0.527 0.506-0.982 1.131-1.288 1.133-0.554 2.842-2.575 3.223-4.143 1.023-4.253-1.785-9.566-2.188-10.295 0.203-0.52 0.402-1.002 0.582-1.414 0.225-0.524 0.521-1.154 0.869-1.809 0.682 1.395 3.738 7.993 2.848 12.443 -0.838 4.195-4.582 9.118-5.879 10.728 -0.242 0.3-0.393 0.594-0.33 0.668 0.064 0.071 0.318-0.106 0.561-0.404 1.314-1.618 5.094-6.561 5.963-10.908 0.066-0.333 0.111-0.677 0.139-1.028 0.184-0.334 1.363-2.558 1.674-5.536 0.395-3.788-0.518-9.343-0.695-10.369 0.441-0.039 0.764 0.149 0.982 0.368 0.268 0.268 0.453 0.552 0.535 0.512 0.08-0.041 0.023-0.384-0.223-0.676 -0.342-0.397-0.926-0.791-1.813-0.461 -2.148 0.792-3.861 3.867-4.92 6.307 -0.92 2.123-2.326 6.037-2.578 8.097 -0.066 0.55 0.043 1.328 0.158 2.151 0.127 0.904 0.256 1.839 0.133 2.395C156.234 100.618 155.469 101.685 154.729 102.716zM160.064 85.115c0.57-1.026 1.883-2.455 2.678-3.239 0.457 0.936 2.494 7.204 0.459 14.029C163.115 91.315 160.48 85.938 160.064 85.115zM153.367 105.66c0.236-0.793 0.932-1.765 1.609-2.708 0.762-1.063 1.549-2.16 1.76-3.1 0.141-0.631 0.006-1.604-0.127-2.546 -0.105-0.76-0.217-1.546-0.156-2.041 0.066-0.539 0.213-1.21 0.412-1.941 0.645 0.536 3.223 3.154 0.898 9.142 -0.176 0.134-0.348 0.25-0.504 0.328 -0.723 0.353-1.008 0.905-1.281 1.44 -0.305 0.59-0.619 1.201-1.559 1.657C153.789 106.195 153.467 105.818 153.367 105.66z",
    fill: "#ab6957",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3681",
    d: "M144.736 127.176c-4.549 9.887-17.57 28.302-27.601 32.566 -7.442 3.165-26.824 3.165-34.267 0 -10.029-4.265-23.05-22.68-27.601-32.566 -5.29-11.491-14.118-48.623-14.13-48.677 -1.3-4.996-1.996-10.239-2.004-15.645C39.082 28.806 66.289 1.169 99.907 1.116c33.621-0.053 60.913 27.495 60.963 61.543 0.009 5.408-0.669 10.653-1.952 15.653C158.901 78.365 150.045 115.641 144.736 127.176z",
    fill: "#d9b8af",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3682",
    d: "M110.152 1.984c26.994 6.347 47.097 30.857 47.052 60.124 -0.009 5.407-0.704 10.65-2.004 15.646 -0.012 0.054-9.158 37.218-14.396 48.677 -4.417 9.659-16.244 27.271-25.867 31.821 -3.169 1.499-11.439 1.855-14.935 1.855 -3.494 0-11.765-0.356-14.933-1.855 -9.623-4.55-21.451-22.162-25.867-31.821 -5.239-11.459-14.385-48.623-14.396-48.677 -1.3-4.995-1.996-10.239-2.004-15.646C42.756 32.841 62.857 8.331 89.853 1.984 61.03 6.885 39.087 32.276 39.134 62.854c0.008 5.406 0.704 10.649 2.004 15.645 0.012 0.054 8.781 37.213 14.13 48.677 4.602 9.862 17.738 27.917 27.601 32.566 3.671 1.732 13.088 2.374 17.134 2.374 4.043 0 13.464-0.643 17.133-2.374 9.862-4.649 23-22.704 27.601-32.566 5.35-11.464 14.119-48.623 14.13-48.677 1.3-4.996 1.996-10.239 2.004-15.645C160.918 32.276 138.975 6.885 110.152 1.984z",
    fill: "#d1a99e",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3683",
    d: "M144.736 127.176c-4.549 9.887-17.57 28.302-27.601 32.566 -7.442 3.165-26.824 3.165-34.267 0 -10.029-4.265-23.05-22.68-27.601-32.566 -5.29-11.491-14.118-48.623-14.13-48.677 -1.3-4.996-1.996-10.239-2.004-15.645C39.082 28.806 66.289 1.169 99.907 1.116c33.621-0.053 60.913 27.495 60.963 61.543 0.009 5.408-0.669 10.653-1.952 15.653C158.901 78.365 150.045 115.641 144.736 127.176z",
    fill: "none",
    stroke: "#ab6957",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4719",
    d: "M100.2 142.947c-2.832 0.144-3.644-2.753-3.644-2.753s3.931 0.565 6.991-0.353C103.548 139.842 102.692 142.822 100.2 142.947z",
    fill: "url(#SvgjsLinearGradient4720)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4723",
    d: "M100.488 140.76c-1.984 0.1-3.765-0.077-3.877-0.089 -0.138-0.014-0.238-0.136-0.224-0.272 0.015-0.138 0.143-0.233 0.274-0.224 0.041 0.003 4.096 0.405 6.738-0.337 0.131-0.032 0.271 0.041 0.309 0.174s-0.04 0.27-0.173 0.308C102.601 140.582 101.517 140.708 100.488 140.76z",
    fill: "#ab6957",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4724",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4725",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "none",
    stroke: "#ab6957",
    strokeWidth: 0.75,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4440",
    d: "M83.071 89.125c-3.293-0.784-4.969 1.059-9.809 1.166 -8.057 0.177-9.938-0.618-11.199-2.638 -0.523-0.837-1.023-1.928-1.264-2.601l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 0.287 0.666 0.433 1.287 0.465 1.867 -0.19 0.958-0.512 1.878-0.947 2.749C85.411 88.113 84.355 88.729 83.071 89.125z",
    fill: "url(#SvgjsRadialGradient4441)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0.25,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4603",
    d: "M81.235 86.646c-1.087 5.321-5.202 8.456-9.201 6.994 -3.996-1.46-6.356-6.964-5.269-12.286 1.086-5.324 5.211-8.458 9.207-6.996C79.965 75.818 82.323 81.322 81.235 86.646z",
    fill: "#3c8d8e",
    stroke: "#0c5f60",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4604",
    d: "M80.068 86.771c-1.06 4.085-4.26 6.469-7.374 5.332 -2.875-1.053-4.689-4.732-4.454-8.62 1.068-0.112 2.233-0.146 3.444-0.066 -0.012 0.056-0.033 0.104-0.045 0.161 -0.381 1.875 0.509 3.841 1.991 4.384 1.487 0.542 3.001-0.545 3.385-2.419 0.047-0.245 0.073-0.49 0.081-0.732C78.112 85.304 79.109 85.942 80.068 86.771z",
    fill: "#529c9d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4605",
    d: "M75.015 81.018c-1.501-0.574-3.035 0.569-3.422 2.564 -0.389 1.986 0.515 4.063 2.017 4.638 1.505 0.575 3.039-0.569 3.426-2.555C77.427 83.669 76.52 81.591 75.015 81.018zM75.344 88.071c-0.625 0.258-1.271-0.085-1.443-0.771 -0.166-0.685 0.205-1.444 0.833-1.698 0.629-0.259 1.273 0.086 1.447 0.767C76.35 87.05 75.978 87.812 75.344 88.071z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4606",
    d: "M70.014 89.265c-0.463 0.37-1.152 0.04-1.548-0.744 -0.396-0.777-0.335-1.708 0.129-2.079 0.458-0.364 1.156-0.034 1.549 0.744C70.532 87.964 70.477 88.896 70.014 89.265z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4607",
    d: "M79.888 83.568c-1.058 0.843-2.647 0.083-3.547-1.701 -0.9-1.786-0.764-3.92 0.293-4.762 1.056-0.849 2.646-0.087 3.542 1.699C81.074 80.589 80.945 82.721 79.888 83.568z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4465",
    d: "M53.729 84.098c-0.382 3.304 9.854 22.004 20.071 22.004s19.5-5.292 19.5-22.003c0-17.789-9.283-22.001-19.5-22.001S55.626 67.704 53.729 84.098zM60.8 85.053l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 1.396 3.231-0.409 5.477-3.529 6.438 -3.293-0.784-4.969 1.059-9.809 1.166 -8.057 0.177-9.938-0.618-11.199-2.638C61.54 86.816 61.04 85.726 60.8 85.053z",
    fill: "#d9b8af",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4466",
    d: "M59.698 82.412c0.023 7.534 7.646 13.604 17.038 13.566 9.389-0.043 16.985-6.179 16.961-13.713 -0.023-7.533-7.647-13.605-17.04-13.566C67.265 68.743 59.673 74.878 59.698 82.412zM60.8 85.053l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 1.396 3.231-0.409 5.477-3.529 6.438 -3.293-0.784-4.969 1.059-9.809 1.166 -8.057 0.177-9.938-0.618-11.199-2.638C61.54 86.816 61.04 85.726 60.8 85.053z",
    fill: "url(#SvgjsRadialGradient4467)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4471",
    d: "M62.063 87.654c-0.523-0.837-1.023-1.928-1.264-2.601l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 1.396 3.231-0.409 5.477-3.529 6.438 -3.293-0.784-4.969 1.059-9.809 1.166C65.206 90.469 63.324 89.673 62.063 87.654z",
    fill: "url(#SvgjsRadialGradient4472)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4475",
    d: "M89.465 81.193c-9.617-5.761-16.701-6.128-28.117-5.394C70.877 74.298 81.852 75.387 89.465 81.193z",
    fill: "#ab6957",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4476",
    d: "M88.23 85.283c-3.24-8.315-25.943-8.364-27.431-4.181v3.895c-1.021-1.539-1.047-1.633-1.483-3.404l-2.195 0.746c0 0 2.746-3.873 5.299-4.381C84.606 73.539 88.04 83.949 88.23 85.283zM84.743 89.42c-4.625-1.98-5.94 0.378-11.563 0.495 -8.004 0.168-9.567-0.766-11.125-2.476 0.813 2.091 1.375 3.085 10.875 3.027C78.306 90.433 81.243 88.212 84.743 89.42z",
    fill: "#092e0c",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4448",
    d: "M116.529 89.125c3.293-0.784 4.969 1.059 9.809 1.166 8.057 0.177 9.938-0.618 11.199-2.638 0.523-0.837 1.023-1.928 1.264-2.601l0.1-4.149c-1.328-3.949-19.541-4.352-25.9 1.784 -0.287 0.666-0.433 1.287-0.465 1.867 0.19 0.958 0.512 1.878 0.947 2.749C114.189 88.113 115.245 88.729 116.529 89.125z",
    fill: "url(#SvgjsRadialGradient4449)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,-0.25,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4608",
    d: "M133.234 86.646c-1.088 5.321-5.203 8.456-9.202 6.992 -3.994-1.458-6.356-6.963-5.267-12.284 1.087-5.324 5.21-8.458 9.204-6.994C131.966 75.818 134.324 81.323 133.234 86.646z",
    fill: "#3c8d8e",
    stroke: "#0c5f60",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4609",
    d: "M132.069 86.771c-1.062 4.085-4.261 6.468-7.375 5.33 -2.875-1.052-4.69-4.73-4.454-8.618 1.067-0.111 2.235-0.146 3.445-0.066 -0.011 0.055-0.035 0.103-0.046 0.161 -0.381 1.875 0.508 3.84 1.99 4.383 1.489 0.542 3.001-0.547 3.385-2.42 0.049-0.244 0.073-0.49 0.083-0.732C130.11 85.305 131.108 85.943 132.069 86.771z",
    fill: "#529c9d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4610",
    d: "M127.017 81.018c-1.504-0.573-3.036 0.569-3.425 2.564 -0.387 1.987 0.515 4.063 2.02 4.637 1.504 0.575 3.035-0.57 3.426-2.555C129.427 83.669 128.52 81.591 127.017 81.018zM127.343 88.071c-0.623 0.258-1.271-0.085-1.44-0.771 -0.168-0.684 0.204-1.445 0.833-1.697 0.629-0.26 1.272 0.085 1.445 0.766C128.351 87.049 127.978 87.811 127.343 88.071z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4611",
    d: "M122.014 89.265c-0.461 0.368-1.15 0.039-1.547-0.745 -0.396-0.776-0.335-1.706 0.128-2.079 0.459-0.364 1.155-0.033 1.547 0.746C122.533 87.964 122.479 88.895 122.014 89.265z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4612",
    d: "M131.888 83.568c-1.06 0.844-2.646 0.083-3.548-1.701 -0.897-1.786-0.766-3.919 0.293-4.761 1.056-0.85 2.646-0.088 3.54 1.698C133.074 80.591 132.945 82.722 131.888 83.568z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4486",
    d: "M125.801 62.098c-10.217 0-19.5 4.212-19.5 22.001 0 16.711 9.283 22.003 19.5 22.003s19.891-18.032 20.07-22.004C146.617 67.611 136.018 62.098 125.801 62.098zM137.537 87.654c-1.261 2.02-3.143 2.815-11.199 2.638 -4.84-0.107-6.516-1.95-9.809-1.166 -3.12-0.961-4.925-3.207-3.529-6.438 6.359-6.136 24.572-5.733 25.9-1.784l-0.1 4.149C138.561 85.726 138.061 86.816 137.537 87.654z",
    fill: "#d9b8af",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4487",
    d: "M122.943 68.699c-9.393-0.04-17.016 6.033-17.039 13.566 -0.025 7.535 7.572 13.67 16.961 13.713 9.391 0.037 17.014-6.033 17.037-13.566C139.928 74.878 132.336 68.743 122.943 68.699zM137.537 87.654c-1.261 2.02-3.143 2.815-11.199 2.638 -4.84-0.107-6.516-1.95-9.809-1.166 -3.12-0.961-4.925-3.207-3.529-6.438 6.359-6.136 24.572-5.733 25.9-1.784l-0.1 4.149C138.561 85.726 138.061 86.816 137.537 87.654z",
    fill: "url(#SvgjsRadialGradient4488)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4492",
    d: "M137.537 87.654c0.523-0.837 1.023-1.928 1.264-2.601l0.1-4.149c-1.328-3.949-19.541-4.352-25.9 1.784 -1.396 3.231 0.409 5.477 3.529 6.438 3.293-0.784 4.969 1.059 9.809 1.166C134.395 90.469 136.276 89.673 137.537 87.654z",
    fill: "url(#SvgjsRadialGradient4493)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4496",
    d: "M110.136 81.193c9.617-5.761 16.701-6.128 28.117-5.394C128.724 74.298 117.749 75.387 110.136 81.193z",
    fill: "#ab6957",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4497",
    d: "M137.181 77.957c2.553 0.508 5.299 4.381 5.299 4.381l-2.195-0.746c-0.437 1.771-0.463 1.865-1.483 3.404v-3.895c-1.487-4.183-24.19-4.134-27.431 4.181C111.561 83.949 114.994 73.539 137.181 77.957zM126.67 90.467c9.5 0.058 10.063-0.937 10.875-3.027 -1.558 1.71-3.121 2.644-11.125 2.476 -5.622-0.117-6.938-2.476-11.563-0.495C118.357 88.212 121.295 90.433 126.67 90.467z",
    fill: "#092e0c",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3128",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient3129)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3132",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient3133)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4613",
    d: "M53.149 74.996c9.743-15.115 36.491 5.148 38.018-1.191 0.299-1.271-0.407-2.015-1.564-2.492C75.982 65.807 57.955 61.18 53.149 74.996z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4614",
    d: "M146.851 74.996c-9.743-15.115-36.491 5.148-38.018-1.191 -0.299-1.271 0.407-2.015 1.564-2.492C124.018 65.807 142.045 61.18 146.851 74.996z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3391",
    d: "M100.729 120.838c-0.354 0.161-1.185 0.161-1.448-0.103 0 0-6.296-2.153-5.498-4.215 1.264-3.262 12.727-0.761 12.717 0C106.475 118.462 100.729 120.838 100.729 120.838z",
    fill: "#ca9b8e",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3392",
    d: "M92.215 113.609c0 0 5.448-18.624 6.008-22.61 1.063 6.47-1.503 20.873-1.774 23.812 -0.329 3.569 3.455 5.688 3.455 5.688 0.293 0.371-0.061 0.602-0.516 0.456l-6.631-2.559C91.186 117.061 91.186 115.79 92.215 113.609zM103.176 116.911c0.915 0.207 1.106 0.576 1.035 0.957 -0.069 0.385-0.462 0.911-1.288 0.43 -0.907-0.526-2.619-0.767-2.619-0.767S102.261 116.701 103.176 116.911z",
    fill: "#ab6957",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3593",
    d: "M71.7 128.57c0.26 1.18 0.08 1.62-0.33 2.5C71.68 129.72 71.69 129.7 71.7 128.57zM98.59 157.65c-0.02-1.21-0.44-1.85-1.56-2.22C97.93 156.04 98.36 156.59 98.59 157.65zM94.8 156.56c-0.05-1.04-0.28-1.67-1.1-2.33C94.26 155.02 94.5 155.56 94.8 156.56zM90.87 155.24c0.08 0.46 0.74 1.31 1.33 1.5C91.71 156.46 90.87 155.24 90.87 155.24zM87.2 153.57c0.08 0.24 0.68 1.88 0.83 1.67C88.04 155.24 87.08 153.22 87.2 153.57zM89.7 150.74c-0.25 1-0.3 1.59-0.17 2.67C89.63 152.79 89.71 151.23 89.7 150.74zM91.87 147.9c-0.09 0.77-0.1 1.57 0 2.33C91.96 149.57 91.98 148.8 91.87 147.9zM93.04 152.74c0.66-0.85 0.89-1.29 1.17-2.33C94 150.74 93.19 152.38 93.04 152.74zM96.7 150.4c-0.08 1.28 0.04 1.85 0.5 2.83C96.84 151.54 96.96 152.13 96.7 150.4zM95.2 148.9c0.42-0.82 0.57-1.29 0.67-2.17C95.69 147.17 95.3 148.49 95.2 148.9zM99.04 147.4c-0.07 0.62 0.05 1.77 0.67 1.67C99.24 149.15 99.1 147.86 99.04 147.4zM95.2 144.9c0.32-0.74 0.56-1.58 0.67-2.33C95.54 143.32 95.32 144.13 95.2 144.9zM88.2 146.74c-0.29 0.88-0.39 1.45-0.33 2.5C87.97 148.78 88.17 147.23 88.2 146.74zM85.37 153.07c0.51-1 0.7-1.62 0.83-2.67C85.97 150.96 85.52 152.4 85.37 153.07zM83.04 150.57c-0.54 0.6 0.17 1.67 0.17 1.67C83.19 151.52 82.81 151.17 83.04 150.57zM84.04 144.8c0-0.06-0.12 0.23 0.16 2.6 0.06-2.55-0.17-2.93-0.17-2.5C84.04 144.9 84.04 144.86 84.04 144.8zM80.2 146.9c0.08 1.47 0.03 2.06 0.33 3C80.43 147.77 80.47 147.9 80.2 146.9zM77.7 147.07c-0.18 0.83-0.21 1.34 0.33 2C77.67 148.33 77.7 147.92 77.7 147.07zM73.54 144.9c0.02-0.51-0.01-1.11-0.15-1.68C73.39 143.13 73.32 143.89 73.54 144.9zM75.26 145.49c0 0 0.61-2.92 0.61-2.92C75.45 143.28 75.26 145.49 75.26 145.49zM78.7 141.9c-0.55 0.52-0.86 1.66-0.83 2.33C77.98 143.79 78.41 142.34 78.7 141.9zM81.37 144.74c0.25-1.07 0.3-1.7 0.17-2.83C81.43 142.58 81.36 144.19 81.37 144.74zM81.2 136.24c-0.2 0.65-0.24 0.95-0.17 1.67C81.05 137.83 81.2 136.3 81.2 136.24zM78.54 138.9c0.46-0.63 0-2.33 0-2.33S78.67 138.6 78.54 138.9zM74.87 137.74c0.17 0.83 0.46 1.74 0.83 2.5C75.54 139.41 75.25 138.53 74.87 137.74zM71.54 137.74c-0.3 1.81-0.06 2.33 0.33 3.33C71.63 139.59 71.56 139.4 71.54 137.74zM69.04 135.74c-0.4 0.64-0.54 2.16 0.17 3C68.8 137.97 68.84 136.33 69.04 135.74zM69.87 130.57c0 0-0.5 0.94-0.5 2.33C69.55 132.11 69.75 131.2 69.87 130.57zM73.04 133.07c0 0-0.83 0.06-0.5 2.5C72.91 132.51 73.04 133.07 73.04 133.07zM77.2 134.07c0.27-0.84 0.45-1.75 0.5-2.67C77.42 132.26 77.26 133.17 77.2 134.07zM75.2 127.9c-0.46 1.05-0.54 1.45-0.5 2.5C74.7 130.4 75.2 127.9 75.2 127.9zM79.2 126.24c-0.67 0.58-0.88 2.11-0.83 3C78.83 126.52 79.2 126.24 79.2 126.24zM83.7 126.4c-0.8 0.64-1.12 1.1-1.33 2.33C82.76 127.78 82.85 127.44 83.7 126.4zM86.54 129.07c0.64-0.63 1.5-3.33 1.5-3.33C87.86 125.39 86.75 128.72 86.54 129.07zM91.54 125.74c-0.56 0.13-1.43 2.64-1.67 3.17C90.17 128.48 91.54 125.74 91.54 125.74zM94.7 125.57c-0.48 0.99-0.74 1.51-1 2.67C94.18 127.29 94.41 126.51 94.7 125.57zM98.7 125.07c-0.76 1.71-0.43 1.22-1.33 3C97.94 127.36 98.37 126.74 98.7 125.07zM128.3 128.57c-0.26 1.18-0.08 1.62 0.33 2.5C128.32 129.72 128.31 129.7 128.3 128.57zM103.46 155.24c-1.12 0.37-1.49 0.68-1.5 1.89C102.19 156.06 102.56 155.84 103.46 155.24zM106.32 154.71c-0.82 0.66-1.14 1.49-1.19 2.53C105.43 156.24 105.77 155.49 106.32 154.71zM107.8 156.74c0.59-0.19 1.26-1.04 1.33-1.5C109.13 155.24 108.29 156.46 107.8 156.74zM111.96 155.24c0.15 0.21 0.75-1.42 0.83-1.67C112.92 153.22 111.96 155.24 111.96 155.24zM110.46 153.4c0.13-1.08 0.08-1.67-0.17-2.67C110.29 151.23 110.37 152.79 110.46 153.4zM108.13 150.24c0.1-0.77 0.09-1.57 0-2.33C108.02 148.8 108.04 149.57 108.13 150.24zM105.8 150.4c0.28 1.04 0.51 1.49 1.17 2.33C106.81 152.38 106 150.74 105.8 150.4zM102.8 153.24c0.46-0.99 0.58-1.55 0.5-2.83C103.04 152.13 103.16 151.54 102.8 153.24zM104.13 146.74c0.1 0.88 0.24 1.35 0.67 2.17C104.7 148.49 104.31 147.17 104.13 146.74zM101.3 148.07c0.61 0.1 0.74-1.05 0.67-1.67C101.9 146.86 101.76 148.15 101.3 148.07zM104.13 142.57c0.11 0.75 0.35 1.59 0.67 2.33C104.68 144.13 104.46 143.32 104.13 142.57zM112.13 149.24c0.06-1.05-0.04-1.62-0.33-2.5C111.83 147.23 112.03 148.78 112.13 149.24zM113.8 150.4c0.13 1.04 0.33 1.67 0.83 2.67C114.48 152.4 114.03 150.96 113.8 150.4zM116.8 152.24c0 0 0.71-1.06 0.17-1.67C117.19 151.17 116.81 151.52 116.8 152.24zM115.96 144.9c0-0.43-0.22-0.05-0.17 2.5 0.28-2.37 0.16-2.66 0.16-2.6C115.96 144.86 115.96 144.9 115.96 144.9zM119.46 149.9c0.3-0.94 0.25-1.53 0.33-3C119.53 147.9 119.57 147.77 119.46 149.9zM121.96 149.07c0.54-0.66 0.51-1.17 0.33-2C122.3 147.92 122.33 148.33 121.96 149.07zM126.61 143.23c-0.14 0.57-0.17 1.17-0.15 1.68C126.68 143.89 126.61 143.13 126.61 143.23zM124.13 142.57c0 0 0.61 2.92 0.61 2.92S124.55 143.28 124.13 142.57zM122.13 144.24c0.03-0.67-0.29-1.81-0.83-2.33C121.59 142.34 122.02 143.79 122.13 144.24zM118.46 141.9c-0.14 1.13-0.09 1.76 0.17 2.83C118.64 144.19 118.57 142.58 118.46 141.9zM118.96 137.9c0.07-0.72 0.03-1.02-0.17-1.67C118.8 136.3 118.95 137.83 118.96 137.9zM121.46 136.57c0 0-0.46 1.7 0 2.33C121.33 138.6 121.46 136.57 121.46 136.57zM124.3 140.24c0.37-0.76 0.67-1.67 0.83-2.5C124.75 138.53 124.46 139.41 124.3 140.24zM128.13 141.07c0.4-1 0.64-1.53 0.33-3.33C128.44 139.4 128.37 139.59 128.13 141.07zM130.8 138.74c0.71-0.84 0.57-2.36 0.17-3C131.16 136.33 131.2 137.97 130.8 138.74zM130.63 132.9c0-1.4-0.5-2.33-0.5-2.33C130.25 131.2 130.45 132.11 130.63 132.9zM127.46 135.57c0.33-2.44-0.5-2.5-0.5-2.5S127.09 132.51 127.46 135.57zM122.3 131.4c0.05 0.91 0.23 1.83 0.5 2.67C122.74 133.17 122.58 132.26 122.3 131.4zM125.3 130.4c0.04-1.05-0.04-1.45-0.5-2.5C124.8 127.9 125.3 130.4 125.3 130.4zM121.63 129.24c0.05-0.89-0.17-2.42-0.83-3C120.8 126.24 121.17 126.52 121.63 129.24zM117.63 128.74c-0.21-1.24-0.53-1.7-1.33-2.33C117.15 127.44 117.24 127.78 117.63 128.74zM111.96 125.74c0 0 0.86 2.7 1.5 3.33C113.25 128.72 112.14 125.39 111.96 125.74zM110.13 128.9c-0.24-0.53-1.1-3.04-1.67-3.17C108.46 125.74 109.83 128.48 110.13 128.9zM106.3 128.24c-0.26-1.15-0.52-1.68-1-2.67C105.59 126.51 105.82 127.29 106.3 128.24zM102.63 128.07c-0.91-1.78-0.57-1.29-1.33-3C101.63 126.74 102.05 127.36 102.63 128.07zM100.51 151.66c-1.02 1.58-0.98 2.27-0.95 3.27C99.85 153.5 99.83 153.51 100.51 151.66zM97.93 142.95c0.51 1.42 0.57 1.57 0.82 2.59C98.72 144.45 98.5 143.87 97.93 142.95zM100.79 145.08c0.25-1.02 0.78-0.71 1.29-2.13C101.5 143.87 100.81 144 100.79 145.08z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3597",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4567",
    d: "M152.983 98.604c-4.563-12.435 0.717-31.506-8.205-45.615 -4.064-6.762-7.597-11.409-6.95-19.276l-0.368-0.124c-0.862 1.352-1.994 2.82-2.745 3.76 0.427-1.091 1.123-2.762 1.753-4.023l-0.332-0.218c-2.585 3.073-4.805 4.649-7.859 5.5 3.3-2.32 6.949-6.357 8.546-8.595l-0.271-0.284c-11.319 7.283-24.164 7.382-35.496 7.471 -10.227 0.076-16.579-0.155-23.953-4.441 -5.321 1.764-9.511 1.539-14.116-1.635 -14.414 27.947-8.01 13.957-16.627 65.764 -5.004-6.67-6.458-10.912-7.642-17.267 -0.313-2.027-0.619-5.154-0.429-7.215l-0.063-0.065c-4.452-9.77-6.553-15.333-5.495-34.712 0.785-8.04 2.533-14.076 7.574-20.398 -0.665-3.435-0.729-6.898-0.277-10.21 -2.64-4.827-4.457-9.795-5.165-11.57 3.688 2.823 3.993 2.986 7.07 3.957 0.704-1.937 1.73-3.861 2.387-4.865 0.297 2.238 0.533 3.75 1.203 5.925 0.228 0.055 1.313 0.349 1.66 0.442 -0.199-1.324-0.381-1.938-0.353-3.125 0.571 1.302 1.053 1.604 2.71 3.626 1.834 0.385 1.394 0.328 1.944 0.328 -2.669-4.183-4.47-7.885-4.927-13.515 3.653 2.081 8.764 3.27 14.101 3.27 12.539 0 25.369-9.412 43.169-9.412 15.425 0 28.771 8.558 34.683 18.303 -0.006-2.514-0.113-4.594 0.794-7.178 0 0 0.105 3.705 0.105 6.592l0.396 0.037c0.62-3.301 1.928-6.115 4.088-8.773 -1.918 5.158-1.188 2.404-3.334 8.702l0.348 0.187c1.431-1.839 2.603-3.139 6.019-4.862 -2.468 2.473-4.355 3.89-5.522 5.639l0.301 0.259c1.456-1.32 2.971-1.82 4.512-0.613 -2.481-0.902-3.946 0.679-5.648 2.675 6.619 1.091 10.21 4.91 14.864 10.015 10.712 12.352 13.533 24.411 7.723 41.506 2.435 5.263 2.06 17.125-3.375 26.686C159.779 86.867 155.941 93.789 152.983 98.604z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4568",
    d: "M62.299 30.371c0.359 0.334 0.718 0.668 1.074 1.004 -0.129-0.085-0.258-0.164-0.388-0.253 -14.414 27.947-8.01 13.957-16.627 65.764 -5.004-6.67-6.458-10.912-7.642-17.267 -0.313-2.027-0.619-5.154-0.429-7.215l-0.063-0.065c-4.452-9.77-6.553-15.333-5.495-34.712 0.785-8.04 2.533-14.076 7.574-20.398 -0.654-3.378-0.72-6.782-0.293-10.044 0.597 0.874 1.223 1.725 1.863 2.565C42.304 12.374 42.669 14.933 42 17c-9.539 29.478-4 43 2 64 -2.464-15.931-7.142-36.185 5.619-48C44.168 46.096 45.673 52.034 47 61 47.917 49.082 52.195 37.996 62.299 30.371zM155.432 13.06c-0.376-0.412-0.742-0.812-1.106-1.207 -0.382 0.255-0.774 0.489-1.159 0.737 14.956 30.661 0.594 27.717 4.017 41.409C161.183 63.999 156 70 156 80c0-15-0.681-25.439-8.96-37.175 -2.796-3.963-3.581-17.423-5.465-24.074C118.373 33 84.002 35.981 47.916 7.183c17 6 51.649 1.35 63.543-6.316 -13.558 2.461-41.862 2.608-54.59-2.631 30.5-2.37 30.131-12.16 56.131-14C100.5-20.431 73.196-8.51 60.658-8.51c-5.336 0-10.447-1.188-14.101-3.27 0.457 5.63 2.258 9.333 4.927 13.515 -0.551 0-0.11 0.057-1.944-0.328 -1.658-2.022-2.14-2.325-2.71-3.626 -0.029 1.187 0.154 1.801 0.353 3.125 -0.347-0.093-1.433-0.387-1.66-0.442 -0.67-2.175-0.906-3.687-1.203-5.925 -0.656 1.004-1.683 2.928-2.387 4.865 -3.078-0.971-3.382-1.134-7.07-3.957 0.708 1.775 2.525 6.744 5.165 11.57 -0.007 0.055-0.009 0.111-0.016 0.166 6.305 9.235 15.169 16.471 23.363 24.192 4.454 2.924 8.558 3.096 13.729 1.382 7.374 4.286 13.727 4.517 23.953 4.441 11.332-0.088 24.177-0.188 35.496-7.471l0.271 0.284c-1.597 2.238-5.246 6.275-8.546 8.595 3.055-0.852 5.274-2.428 7.859-5.5l0.332 0.218c-0.63 1.262-1.326 2.932-1.753 4.023 0.751-0.94 1.883-2.408 2.745-3.76l0.368 0.124c-0.646 7.868 2.886 12.514 6.95 19.276 8.922 14.109 3.643 33.181 8.205 45.615 2.958-4.815 6.796-11.736 6.796-17.352 5.435-9.561 5.81-21.423 3.375-26.686C168.965 37.471 166.144 25.412 155.432 13.06zM156.165 38.709c-0.33-9.524-6.633-21.612-6.633-21.612 -2.946-5.204-5.579-7.687-9.996-8.695 12.426 0.619 17.306 19.179 16.769 28.875C156.254 38.177 156.165 38.709 156.165 38.709zM127.907-1.507c3.283 2.663 4.067 3.423 7.296 7.909 -16.653-29.889-49.333-7.27-59.667-8C86.041 0.573 109.793-14.79 127.907-1.507zM136.369 11.485C116.408 28.033 85.929 21.023 61 13.21 85.827 24.581 117.435 30.734 136.369 11.485zM57.869 29.485c-6.539 3.425-9.616 12.05-9.9 17.75C49.19 42.316 52.854 33.291 57.869 29.485zM49.619 24.735c-9.359 5.699-11.174 18.771-10.25 29.75C40.353 44.343 42.181 31.11 49.619 24.735zM117.064 12.34c-1.006 0.215-7.259 1.072-10.672 1.195 -2.661 0.155-13.037 0.328-22.391-0.048 9.655 2.069 15.454 2.454 22.496 2.045 8.106-0.293 15.36-1.898 21.371-6.796C123.633 11.067 121.828 11.399 117.064 12.34zM150.609 38.885c0 0-0.256-0.441-0.588-1.102 -0.911-1.527-1.945-5.681-5.938-18.736 2.966 24.195 7.817 19.782 9.991 32.283C154.075 46.834 153.761 44.529 150.609 38.885z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4569",
    d: "M157.853 68.131c0.364-3.246 0.217-1.758 0.257-3.61 0.306-6.244-3.426-11.479-1.154-18.987 1.854-5.453 2.925-6.308 2.113-15.801 -0.119-1.37-0.474-4.774-1.102-5.998 0.856 1.489 1.422 4.245 1.725 5.934 1.687 9.543 0.268 10.992-1.521 16.267C155.781 53.906 160.368 57.422 157.853 68.131zM141.575 18.751c1.117 30.37 7.276 23.316 12.717 41.752C150.598 38.757 147.181 56.786 141.575 18.751zM48.369 34.235c-9.19 11.563-8.262 19.899-6 37C42.165 53.925 40.055 47.355 48.369 34.235zM41.772 17.714c-5.274 16.319-6.429 23.684-3.897 41.285C37.406 41.353 37.518 37.458 41.772 17.714zM61.952 30.641C52.322 37.56 47.295 50.217 47 61 48.482 50.695 54.012 37.697 61.952 30.641zM128.855 24.594c-12.051 4.437-31.667 5.625-45.988 1.322C71.706 22.661 54.279 11.723 44.905 4.845c8.498 6.765 23.471 16.807 33.926 20.776 10.863 4.059 27.887 5.567 41.081 2.245 9.248-2.324 14.041-4.52 21.663-9.114C138.182 20.612 133.184 23.242 128.855 24.594zM102.813-11.594c12.167-2.285 26.509 5.558 34.057 14.83 -7.897-11.318-20.837-16.949-28.562-17.083C95.629-14.067 82.513-3.204 56.869-2.265 80.982-1.203 92.573-9.936 102.813-11.594zM112.369 1.235c-17.289 6.143-30.64 7.613-48.807 8.58C82.325 10.97 95.739 9.15 112.369 1.235zM130.536 4.738c-10.662 5.027-15.33 5.851-37.337 7.191C106.996 12.486 119.885 11.769 130.536 4.738zM95.248 20.023c10.644 1.237 29.289-0.105 38.621-9.788 -11.27 9.494-32.119 9.154-48.38 8.508C91.713 19.714 90.59 19.552 95.248 20.023zM140.869 10.735c7.629 2.809 9.489 16.193 12.5 27C152.022 28.156 149.721 12.813 140.869 10.735z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4570",
    d: "M155.579 12.925c-4.348-4.769-8.252-8.97-14.63-10.02 2.094-2.463 3.566-3.379 6.25-1.85 -1.59-1.871-3.417-2.226-5.63-0.22 1.271-1.905 3.468-3.46 6.3-6.43 -4.231 1.985-5.503 3.34-7.12 5.42 2.285-6.703 1.3-3.128 3.72-9.75 -2.529 2.836-4.146 5.92-4.859 9.72 0-5.903-0.185-5.14-0.07-7.72 -1.387 3.089-1.229 5.81-1.229 7.59 -2.233-3.682-5.514-6.8-9.051-9.35 -25.054-18.289-50.039-1.456-63.58 0.58 -5.489 0.927-13.714 0.338-19.35-3.04 0.398 5.764 2.183 9.592 4.79 13.68 -0.001 0-1.47-0.31-1.47-0.31 -2.019-2.434-2.214-2.356-2.96-4.33 -0.191 1.763 0.101 2.74 0.25 3.74 -0.498-0.13-0.957-0.268-1.26-0.34 -0.743-2.414-0.958-4.25-1.23-6.29 -0.614 0.785-1.922 3.18-2.64 5.15 -2.999-0.948-3.214-1.099-7.43-4.33 0.5 1 2.309 6.461 5.44 12.23 -0.47 3.534-0.328 7.06 0.27 10.12 -5.025 6.312-6.77 12.346-7.56 20.44 -1.041 19.059 0.867 24.611 5.53 34.82 0.01 0.01 0.01 0.03 0.02 0.04 -0.177 1.971 0.119 5.102 0.44 7.18 1.179 6.332 2.625 10.693 7.91 17.65 0.02 0.02 0.03 0.05 0.05 0.07 3.395-20.368 3.045-20.867 3.77-25.89 3.572-25.712 3.417-21.872 12.81-40.07 3.813 2.628 8.035 3.552 14.02 1.56 4.342 2.524 8.776 4.45 21.06 4.45 12.171-0.152 26.176 0.412 38.52-7.53 -1.87 2.622-6.118 7.154-9.46 9.18 3.479-0.736 5.975-2.137 9.09-5.84 -0.957 1.915-2.083 4.814-2.17 5.16 0.15-0.18 2.15-2.57 3.51-4.7 -0.653 7.945 2.894 12.597 6.98 19.4 8.956 14.163 3.511 33.521 8.33 45.96 3.09-4.996 7.04-12.086 7.04-17.75 5.21-9.086 5.956-21.111 3.39-26.75C168.587 38.924 167.533 26.708 155.579 12.925zM46.789-2.465c0.488 1.389 0.595 1.359 2.49 3.61 -0.94-0.195-1.565-0.332-2.13-0.46C46.93-0.371 46.789-1.375 46.789-2.465zM44.279-5.125c0.094 1.532 0.459 3.542 0.99 5.31 -2.865-0.737-1.8-0.504-2.8-0.8C43.292-3.089 43.602-3.715 44.279-5.125zM45.999 95.095c-4.216-7.605-5.323-10.191-6.49-17.89 -0.114-0.886-0.472-3.446-0.49-4.67 -6.07-13.88-8.352-40.236 1.21-54.74 0-0.01 0-0.01 0-0.01s0.399-0.624 1.12-1.52c-0.267-1.344-0.531-4.18-0.44-7.28 0.74 1.32 1.58 2.52 2.33 3.67 0-0.003 0.59 0.781 0.59 0.8 4.551 5.79 8.754 10.604 18.92 17.75C50.544 50.979 51.301 44.3 45.999 95.095zM163.639 48.206c-0.356 2.358-1.123 5.583-1.539 6.99 2.78 7.068-0.257 20.417-3.061 26.38 -1.226 7.093-2.545 8.521-6.01 15.59 -2.477-11 2.583-30.519-6.76-45.08 -6.059-10.044-8.657-11.36-7.23-23.77 0 0 0.061-0.675 0.08-0.85 -12.628 7.721-26.576 8.594-44.97 8.2 -5.317 0-12.5-0.668-16.98-3.44 -9.081 2.583-12.45-1.437-20.01-7.34 -8.163-6.937-13.709-12.994-20.55-27.27 3.843 3.118 11.537 4.689 16.39 5.5 -3.273-4.363-5.199-8.349-6.07-14 3.48 2.32 11.82 4.603 19.17 3.79 13.534-1.271 32.484-15.167 55.77-4.63 10.804 4.767 16.286 11.476 17.57 15 0.01 0 0.02 0.01 0.04 0.01 0.06 0.02 0.12 0.03 0.189 0.04 0.017 0.018 0.332 0.09 0.36 0.09 6.976 2.325 7.443 2.759 14.2 10.64C158.026 18.715 167.168 28.016 163.639 48.206z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4715",
    d: "M148.02 85.54c-0.11 1.96-0.35 4.05-0.59 6.25 -1.04 9.74-5.26 12.49-24.57 11.1 -6.3-0.45-11.06-4.04-13.41-10.1 -0.99-2.55-1.87-5.52-2.37-8.48C116.7 77.81 139.4 77.62 148.02 85.54zM51.98 85.54c0.11 1.96 0.35 4.05 0.59 6.25 1.04 9.74 5.26 12.49 24.57 11.1 6.3-0.45 11.06-4.04 13.41-10.1 0.99-2.55 1.87-5.52 2.37-8.48C83.3 77.81 60.6 77.62 51.98 85.54z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4716",
    d: "M148.02 85.54c-8.62-7.92-31.33-7.73-40.93-1.23 -0.36-2.11-0.52-4.22-0.36-6.16h0c0.66-7.81 13.45-6.88 20.98-7.17C146.33 70.26 148.56 76.34 148.02 85.54zM93.27 78.14L93.27 78.14c-0.66-7.81-13.45-6.88-20.99-7.17 -18.61-0.71-20.85 5.37-20.31 14.56 8.62-7.92 31.33-7.73 40.93-1.23C93.26 82.19 93.43 80.09 93.27 78.14z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4717",
    d: "M149.91 75.08c-0.62-1.42-1.48-2.7-2.56-3.65 -2.47-2.16-7.08-2.46-11.39-2.71 -4.19-0.23-12.15-0.42-17.46-0.08 -13.8 0.9-13.57 7-13.57 7 -1.81 0-8.03 0-9.84 0 0 0 0.23-6.11-13.57-7 -5.32-0.34-13.27-0.16-17.46 0.08 -4.31 0.24-8.93 0.55-11.39 2.71 -1.09 0.95-1.94 2.22-2.56 3.65l-8.19-1.58v3.99c7.17 1.38 9.02 1.82 10.02 1.76 -0.25 3.01-0.36 8.35 0.29 12.59 1.54 10.07 5.78 12.78 24.94 11.4 6.36-0.46 11.35-4.23 13.72-10.33 1.86-4.8 3.14-9.09 2.81-14.28h12.64c-0.33 5.19 0.95 9.49 2.81 14.28 2.36 6.1 7.36 9.87 13.72 10.33 19.17 1.38 23.41-1.33 24.94-11.4 0.65-4.24 0.54-9.58 0.29-12.59 1 0.06 2.85-0.38 10.02-1.76V73.5L149.91 75.08zM90.07 92.61c-2.27 5.87-6.88 9.35-12.98 9.78 -19.08 1.37-22.61-1.33-24.04-10.68 -0.76-5.01-0.35-11.52-0.25-12.52 0.19-0.03 0.31-0.06 0.32-0.1 1.09-6.36 6.45-8.42 29.02-7.35 3.73 0.18 6.92 0.88 8.69 2.75 1.04 1.09 2.04 2.66 1.95 4.17l0.04 0C93.02 81.2 92.44 86.5 90.07 92.61zM146.94 91.72c-1.43 9.35-4.96 12.05-24.04 10.68 -6.1-0.44-10.71-3.92-12.98-9.78 -2.37-6.11-2.94-11.41-2.74-13.95l0.04 0c-0.09-1.5 0.91-3.07 1.95-4.17 1.77-1.87 4.96-2.57 8.69-2.75 22.57-1.06 27.92 0.99 29.02 7.35 0.01 0.04 0.13 0.08 0.32 0.1C147.29 80.2 147.71 86.71 146.94 91.72z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4718",
    d: "M104.94 75.34c0.17-1.26 1.63-5.92 13.54-6.69 5.32-0.34 13.27-0.16 17.46 0.08 4.31 0.24 8.93 0.55 11.39 2.71 1.09 0.95 1.94 2.22 2.56 3.65l0 0c-3.72-6.16-10.22-5.54-14.01-5.75 -2.3-0.13-6.21-0.27-10.28-0.27 -2.77 0-5.15 0.06-7.06 0.19C111.48 69.71 107.56 70.92 104.94 75.34zM95.06 75.34c-0.17-1.26-1.63-5.92-13.54-6.69 -5.32-0.34-13.27-0.16-17.46 0.08 -4.31 0.24-8.93 0.55-11.39 2.71 -1.09 0.95-1.94 2.22-2.56 3.65l0 0c3.72-6.16 10.22-5.54 14.01-5.75 2.3-0.13 6.21-0.27 10.28-0.27 2.77 0 5.15 0.06 7.06 0.19C88.52 69.71 92.44 70.92 95.06 75.34z",
    fill: "#0f0f0f",
    strokeWidth: "none",
    opacity: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d3a8e743550e3d060ec63e8c145ed0d7.svg";
export { ForwardRef as ReactComponent };